export class NotAuthorizedError extends Error {
  status: number;
  constructor(message = 'Unauthorized') {
    super(message);
    this.name = 'Not Authorized';
    this.status = 403;
  }
}
